import { render } from "./StepOne.vue?vue&type=template&id=54a06b40&scoped=true&ts=true"
import script from "./StepOne.vue?vue&type=script&lang=ts"
export * from "./StepOne.vue?vue&type=script&lang=ts"

import "./StepOne.vue?vue&type=style&index=0&id=54a06b40&lang=scss&scoped=true"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a06b40"]])

export default __exports__